import Emitter from "./Emitter";

export default class DepositCanceled extends Emitter {
    constructor(gb) {
        super(gb);
    }

    IGT_handler() {
        this.emitGame(JSON.stringify({ message: "cust2rgsReloadGame" }));
    }

    _default() {
        this.emitGame({ wpgaction: "depositCanceled" });
    }
}